import styled from 'styled-components';

export const AttributePopupWrapper = styled.div`
    .attribute-style {
        background-color: #fff;
        width: 250px;
        .header {
            color: #555;
        }
        > div {
            width: 250px;
        }
        .select-header-icon {
            border-left: 0px;
            color: #aaa;
        }
        .option-select__control {
            height: 41px;
            border: 1px solid #aaa;
            cursor: pointer;
        }
        .option-select__single-value {
            color: #555;
        }
        .option-select__placeholder {
            color: #555;
        }
        &.error-border {
            width: 251px;
        }
    }
    .text-style {
        background-color: #fff;
        width: 120px;
        .header {
            color: #555;
            padding: 8px 7px;
        }
        > div {
            width: 120px;
        }
        .select-header-icon {
            border-left: 0px;
            color: #aaa;
        }
    }
    .row:not(:last-child) {
        margin-bottom: 40px;
    }
    .attribute-input {
        height: 40px;
        border: 1px solid #aaa;
        padding-left: 12px;
        border-radius: 4px;
        color: #555;
        &:focus {
            outline: none;
        }
        &.color-block-input {
            border-radius: 4px 0px 0px 4px;
        }
    }
    .attribute-color-picker {
        position: absolute;
        top: 0px;
        right: 0px;
        transform: translate(0px, 45px);
    }
    .color-outer-input {
        border: 1px solid #aaa;
        border-radius: 4px;
        position: relative;
        height: 42px;
        input {
            border: 0;
        }
    }
`;
